<template>
    <div>
        <div v-if="alliances.length" class="container-fluid bg-discount">
            <div class="justify-content-center py-5">
                <div class="header-descuentos container">
                    <h5 class="mt-0">Descuentos
                        <p>Conectados trae bonos de descuento para ti en diferentes marcas, no necesitas usar tus puntos.</p>
                    </h5>
                    <a class="text-center" href="/descuentos">Ver todos</a>
                </div>
                <div class="container">
                    <div v-if="$mq !== 'sm'" class="row">
                        <div v-for="alliance in alliances" class="col-lg-4 col-md-6 p-2">
                            <div class="bg-white rounded-3 text-bat">
                                <div class="row justify-content-between">
                                    <div class="col-7 px-4 border-right border-dark p-2">
                                        <div class="row d-flex justify-content-between">
                                            <div class="col-7 ">
                                                <h5 class="text-title-bat fs-6 mb-0 truck-title">{{ alliance.category_name }}</h5>
                                            </div>
                                            <div class="col-4 px-0">
                                                <span class="tag-category">{{ alliance.alliance_name }}</span>
                                            </div>
                                        </div> 
                                        <div class="row">
                                            <div class="col-auto pe-0 ">
                                                <h4 class="fs-2 mb-0">{{ alliance.discount }}%</h4>
                                            </div>
                                            <div class="col-4 ps-0">
                                                <p class="lh-base mb-0">de Descuento</p>
                                            </div>
                                        </div>
                                        <a class="text-title-bat text-indigo text-decoration-underline" :href="'/coupon/' + alliance.id + '/detail'">Ver detalle ></a>
                                    </div>
                                    <div class="col-5 ticket-img ps-1">
                                        <div class="box-img position-relative w-100 h-100">
                                            <img class="w-100 h-100 rounded-end" :src="url_media + alliance.short_image" :alt="alliance.category_name">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="$mq === 'sm'">
                        <slick v-if="alliances.length" ref="slick" :options="slickOptionsDiscounts" class="p-2 slick-vue">
                            <div v-for="alliance in alliances" class="p-2">
                                <div class="bg-white rounded-3 text-bat">
                                    <div class="row justify-content-between">
                                        <div class="col-7 px-4 border-right border-dark p-2">
                                            <div class="row d-flex justify-content-between">
                                                <div class="col-7 pe-0">
                                                    <h5 class="text-title-bat fs-6 mb-0 truck-title">{{ alliance.category_name }}</h5>
                                                </div>
                                                <div class="col-4 px-0">
                                                    <span class="tag-category">{{ alliance.alliance_name }}</span>
                                                </div>
                                            </div> 
                                            <div class="row">
                                                <div class="col-auto pe-0 ">
                                                    <h4 class="fs-1 mb-0">{{ alliance.discount }}%</h4>
                                                </div>
                                                <div class="col-4 ps-0">
                                                    <p class="lh-base mb-0 fs-7">de Descuento</p>
                                                </div>
                                            </div>
                                            <a class="text-title-bat text-indigo text-decoration-underline " :href="'/coupon/' + alliance.id + '/detail'">Ver detalle ></a>
                                        </div>
                                        <div class="col-5 ticket-img ps-1">
                                            <div class="box-img position-relative w-100 h-100">
                                                <img class="w-100 h-100 rounded-end" :src="url_media + alliance.short_image" :alt="alliance.category_name">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </slick>
                    </div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';

export default {
    components: {Slick},
    props: {
        url_media: {
            default: '',
        },
    },
    data() {
        return {
            loading: 0,
            alliances: [],
            slickOptionsDiscounts: Object,
        }
    },
    mounted() {
        this.slickOptionsProps()
        this.loadAlliances()
    },
    methods: {
        loadAlliances() {
            this.loading++
            axios.get(`get-partial-alliances`)
                 .then(({data}) => {
                     this.alliances = data.alliances
                     this.loading--
                 })
        },
        slickOptionsProps() {
            this.slickOptionsDiscounts = {
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            }
        },
    }
}
</script>
